/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-25 10:06:15
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-25 13:46:38
 * @FilePath: \hlweb2.0\src\pages\Solution\Archives\Collaborate\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";
function Collaborate() {
  const [activeIndex, setActiveIndex] = useState(null);
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");
  const collaborateCenter = t("solution_archives.archives3", {
    returnObjects: true,
  });
  return (
    <div className="collaborate_">
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div>{collaborateCenter.til}</div>
          <span>{collaborateCenter.detail}</span>
        </div>
      </div>
      <div className="collaborate_con">
        {collaborateCenter.contentList.map((item0, index0) => {
          return (
            <div
              className="collaborate_li"
              key={index0}
              onMouseEnter={() => {
                setActiveIndex(index0);
              }}
              onMouseLeave={() => setActiveIndex(null)}
            >
              <img className="collaborate_li_img" src={item0.imgUrl} alt="" />
              <div className="collaborate_li_body">
                <div className="collaborate_li_til">{item0.tit}</div>
                <div className={`collaborate_li_con ${language === "zh" ? "collaborate_li_con_zh" : "collaborate_li_con_en"}`}>{item0.detail}</div>
                <ul className="collaborate_li_card">
                  {item0.list.map((item1, index1) => {
                    return <li key={index0 + index1}>{item1}</li>;
                  })}
                </ul>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Collaborate;
